import { FormikProps, withFormik } from "formik";
import { Input } from "../shared/Input";
import { number, object, string } from "yup";
import { DatePicker } from "../shared/DatePicker";
import { SearchDropDown } from "../shared/SearchDropDown";
import { useSelector } from "react-redux";

export interface IFormProps {
  onSubmit: (values: any, actions: any) => void;
  item?: any;
  setModal?: any;
}

interface FormikValues {
  firstName: string;
  lastName: string;
  phoneNo: string;
  dateOfBirth: string;
  gender: string;
  cityId: number;
  roles: number[];
}

const Form = (props: FormikProps<FormikValues> & IFormProps) => {
  const { cities } = useSelector((state: any) => state.city);
  
  return (
    <div className="flex flex-col max-h-full relative items-center gap-6 py-6 px-4 max-w-full">
      <form onSubmit={props.handleSubmit} className="w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 w-full gap-4 justify-center">
          <div className="w-full">
            <Input
              name="firstName"
              label="First Name"
              values={props.values}
              onBlur={props.handleBlur}
              onChange={props.handleChange}
              errors={props.errors}
              touches={props.touched}
              placeholder={"Enter your first name"}
            />
          </div>
          <div className="w-full">
            <Input
              name="lastName"
              label="Last Name"
              values={props.values}
              onBlur={props.handleBlur}
              onChange={props.handleChange}
              errors={props.errors}
              touches={props.touched}
              placeholder={"Enter your Last name"}
            />
          </div>
          <div className="w-full">
            <Input
              name="phoneNo"
              label="Mobile Number"
              values={props.values}
              onBlur={props.handleBlur}
              onChange={props.handleChange}
              errors={props.errors}
              touches={props.touched}
              placeholder={"Enter your Mobile Number"}
            />
          </div>
          <div className="w-full">
            <DatePicker
              name="dateOfBirth"
              label="Date of Birth"
              onChange={props.handleChange}
              values={props.values}
              onBlur={props.handleBlur}
              errors={props.errors}
              touches={props.touched}
              format="yyyy.MM.dd"
              maxDate={new Date()}
            />
          </div>
          <div className="w-full">
            <SearchDropDown
              name="gender"
              label="Gender"
              values={props.values}
              onBlur={props.handleBlur}
              onChange={props.handleChange}
              errors={props.errors}
              touches={props.touched}
              placeholder={"Select your Gender"}
              options={[
                { label: "Male", value: "male" },
                { label: "Female", value: "female" },
              ]}
            />
          </div>
          <div className="w-full">
            <SearchDropDown
              name="cityId"
              label="City"
              values={props.values}
              onBlur={props.handleBlur}
              onChange={props.handleChange}
              errors={props.errors}
              touches={props.touched}
              placeholder={"Select your Gender"}
              options={cities}
            />
          </div>
        </div>
        <div className="flex py-3 flex-col items-center justify-center lg:flex-row lg:justify-center lg:items-center gap-3">
          <button
            type="submit"
            className="w-full cursor-pointer lg:w-40 h-12 text-white font-semibold content-center text-center bg-[#05A30D] rounded-lg lg:rounded-none lg:rounded-tl-2xl lg:rounded-br-2xl"
          >
            Save information
          </button>
          <button
            onClick={() => props.setModal(false)}
            className="w-full cursor-pointer lg:w-40 h-12 text-black font-semibold content-center text-center bg-[#C9CCC9] rounded-lg lg:rounded-none lg:rounded-tl-2xl lg:rounded-br-2xl"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default withFormik<IFormProps, FormikValues>({
  validationSchema: object().shape({
    firstName: string().required("Please enter your first name!"),
    lastName: string().required("Please enter your last name!"),
    phoneNo: string()
      .required("Phone number is required!")
      .matches(
        /^\+?[0-9]+$/,
        "Phone number must contain only digits and an optional '+' at the start"
      ),
    dateOfBirth: string().required("Please select your date of birth!"),
    gender: string().required("Please select your gender!"),
    cityId: number().required("Please select your city!"),
  }),
  mapPropsToValues: (props) => ({
    firstName: props.item.firstName,
    lastName: props.item.lastName,
    phoneNo: props.item.phoneNo,
    dateOfBirth: props.item.dateOfBirth,
    gender: props.item.gender,
    cityId: props.item.cityId,
    roles: [2],
  }),
  handleSubmit: (values, { props, ...actions }) => {
    props.onSubmit(values, actions);
    props?.setModal(false);
  },
})(Form);
